import { createRootRoute, Outlet } from '@tanstack/react-router';
import { AuthProvider } from '@/lib/auth/auth-context';
import { TenantProvider } from '@/lib/config/tenant-context';
import { ErrorBoundary } from '@/components/shared/error-boundary';
import { DashboardShell } from '@/components/layout/dashboard-shell';
import { DashboardToaster } from '@/components/layout/dashboard-toaster';
import { PwaPrompts } from '@/components/pwa/pwa-prompts';
import { ThemeProvider } from '@/lib/theme/theme-provider';
import { NavigationProgress } from '@/components/layout/navigation-progress';

export const Route = createRootRoute({
  component: RootLayout,
});

function RootLayout() {
  return (
    <ErrorBoundary>
      <ThemeProvider>
        <TenantProvider>
          <DashboardShell>
            <AuthProvider>
              <NavigationProgress />
              <Outlet />
              <DashboardToaster />
              <PwaPrompts />
            </AuthProvider>
          </DashboardShell>
        </TenantProvider>
      </ThemeProvider>
    </ErrorBoundary>
  );
}
